module.exports = __webpack_public_path__ + "static/media/gi.9b7904df.svg";